module.exports = __webpack_public_path__ + "img/46784c5.jpg";